
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('rect',{attrs:{"width":"24","height":"24","fill":"#593289","fill-opacity":".1","rx":"12"}}),_c('path',{attrs:{"stroke":"#593289","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.5","d":"M9.5 9v6m5-6v6"}})])])
          )
        }
      }
    